export const phpBackendFormattedSeats = (seats = {}) => {
  return Object.keys(seats).map(seatId => {
    const seat = seats[seatId];
    return {
      seat:          seatId,
      priceType:     seat.priceType,
      priceCategory: seat.priceCategory
    };
  });
};

export const phpBackendFormattedGASeats = (seats = {}) => {
  const formattedGASeats = [];
  const GATicketSections = Object.keys(seats);

  GATicketSections.forEach(sectionId => {
    const GAPriceCategories  = seats[sectionId];
    const GAPriceCategoryIds = Object.keys(GAPriceCategories);

    GAPriceCategoryIds.forEach(priceCategoryId => {
      const GAPriceTypes   = GAPriceCategories[priceCategoryId];
      const GAPriceTypeIds = Object.keys(GAPriceTypes);

      GAPriceTypeIds.forEach(priceTypeId => {
        const GATicket = GAPriceTypes[priceTypeId];

        formattedGASeats.push({
          areas:         GATicket.areas,
          priceType:     priceTypeId,
          priceCategory: priceCategoryId,
          quantity:      GATicket.qty,
          acceptNonAdjacentSeats: GATicket.acceptNonAdjacentSeats
        });
      });
    });
  });

  return formattedGASeats;
};



// WEBPACK FOOTER //
// ./frontend/react/utils/transformers/index.js